/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_profile_tooltip_cumulative_fantasy = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Running fantasy points total across the season`)
};

const es_f1_profile_tooltip_cumulative_fantasy = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total acumulado de puntos fantasy a lo largo de la temporada`)
};

const de_f1_profile_tooltip_cumulative_fantasy = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laufende Fantasy-Punkte über die Saison`)
};

const nl_f1_profile_tooltip_cumulative_fantasy = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lopend fantasy-puntentotaal over het seizoen`)
};

const fr_f1_profile_tooltip_cumulative_fantasy = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total cumulatif des points fantasy au fil de la saison`)
};

const it_f1_profile_tooltip_cumulative_fantasy = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Totale progressivo dei punti fantasy durante la stagione`)
};

const pt_br2_f1_profile_tooltip_cumulative_fantasy = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total acumulado de pontos fantasy ao longo da temporada`)
};

const pt_f1_profile_tooltip_cumulative_fantasy = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total acumulado de pontos fantasy ao longo da época`)
};

const ja_f1_profile_tooltip_cumulative_fantasy = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`シーズンを通じた累積ファンタジーポイント`)
};

const zh_f1_profile_tooltip_cumulative_fantasy = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`整个赛季的累计梦幻积分`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_profile_tooltip_cumulative_fantasy = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_profile_tooltip_cumulative_fantasy(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_profile_tooltip_cumulative_fantasy", locale)
	if (locale === "en") return en_f1_profile_tooltip_cumulative_fantasy(inputs)
	if (locale === "es") return es_f1_profile_tooltip_cumulative_fantasy(inputs)
	if (locale === "de") return de_f1_profile_tooltip_cumulative_fantasy(inputs)
	if (locale === "nl") return nl_f1_profile_tooltip_cumulative_fantasy(inputs)
	if (locale === "fr") return fr_f1_profile_tooltip_cumulative_fantasy(inputs)
	if (locale === "it") return it_f1_profile_tooltip_cumulative_fantasy(inputs)
	if (locale === "pt-BR") return pt_br2_f1_profile_tooltip_cumulative_fantasy(inputs)
	if (locale === "pt") return pt_f1_profile_tooltip_cumulative_fantasy(inputs)
	if (locale === "ja") return ja_f1_profile_tooltip_cumulative_fantasy(inputs)
	return zh_f1_profile_tooltip_cumulative_fantasy(inputs)
};